import { Navigate } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";
import LoadingScreen from "./LoadingScreen";

const IsPrivate = ({ children }) => {
  const { isLoggedIn, isSettingUp } = useAuthContext();

  if (isSettingUp) {
    return <LoadingScreen />;
  } else {
    return isLoggedIn ? children : <Navigate to={"/login"} replace />;
  }
};
export default IsPrivate;
